// src/analytics/ga.js
export const GA_ID = 'G-3L1W3TEGZ3'; // ton ID

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export function pageview(path) {
  if (!hasGtag()) return;
  window.gtag('config', GA_ID, { page_path: path });
}

export function trackEvent({ action, category, label, value }) {
  if (!hasGtag()) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
}